import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/global.css'

// Note: StrictMode can cause double-mounting in development
// which may affect camera/detection initialization
ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
